import { FC } from "react";
import { Row, Col, Typography } from "antd";
import * as _ from "lodash";

import { TodoItemStatus } from "@ctra/api";

import { Checkbox } from "../../generic";
import styles from "./TaskOverview.module.less";

const { Text } = Typography;

export interface TaskOverviewProps {
  /**
   * task list
   */
  tasks: Array<{
    label: string;
    status: TodoItemStatus;
  }>;
  /**
   * limit for task ellipsis
   */
  limit?: number;
}

/**
 * Game Plan panel task list component
 * @param {Array<{label: string, status: TodoItemStatus}>} tasks
 * @param {number | undefined} limit
 * @return {null}
 * @constructor
 */
const TaskOverview: FC<TaskOverviewProps> = ({ tasks, limit = 7 }) => (
  <Row gutter={16} align="middle">
    <Col>
      <Row gutter={8} align="middle">
        <Col style={{ lineHeight: 0 }}>
          {_.map(_.take(tasks, limit), ({ label, status }) => (
            <Checkbox key={label} label={label} checked={status === TodoItemStatus.Completed} />
          ))}
        </Col>
        {tasks.length > limit && (
          <Col>
            <Text type="secondary">+{tasks.length - limit}</Text>
          </Col>
        )}
      </Row>
    </Col>
    <Col>
      <Text className={styles.Progress}>
        {_.filter(tasks, ["status", TodoItemStatus.Completed]).length} / {tasks.length}
      </Text>
    </Col>
  </Row>
);

export default TaskOverview;
